import React, { Component } from 'react'
import moment from 'moment'
import { Link } from 'react-router'
import { Col, Row, Button } from 'react-bootstrap'
import Newsletter from '../../../Newsletter'
import Spinner from '../../../Spinner'
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share'
import { translate } from "react-translate"

@translate("ImiDetail")
export default class NewsletterDetail extends Component {

  componentWillMount() {
    window.scrollTo(0,0)
    this.props.loadNoteById(this.props.params.id)
  }

  _renderDate(date){
    moment.locale('es');
    var m = moment(date)
    let day = moment(m).format('dddd')
    let newDate = moment(m).format('LL')
    return (
      <div>{newDate}</div>
    )
  }

  _renderShortDate(date){
    moment.locale('es');
    var m = moment(date)
    let day = moment(m).format('MMMM')
    let year = moment(m).format('YYYY')
    return (
      <span className="text-transform">
        {day} {year}
      </span>
    )
  }

  _magic(input) {
    return {__html: input}
  }

  render () {

    const { note, newsletter, loadNewsletter, notes, t } = this.props

    var style = {
      backgroundImage: 'url(' + note.image + ')'
    }

    let shareStyle = {
      fill: '#292929',
      cursor: 'pointer',
      marginRight: '5px'
    }

    let related_notes = []

    function checkNewsletter () {
      if (!newsletter){
        if (note.newsletter !== undefined){
          loadNewsletter(note.newsletter)
        }
      }
      else{
        related_notes = notes.slice(0,2)
      }
    }

    checkNewsletter()

    const { FacebookShareButton, GooglePlusShareButton, LinkedinShareButton, TwitterShareButton } = ShareButtons;

    const { FacebookShareCount, GooglePlusShareCount, LinkedinShareCount } = ShareCounts;

    const FacebookIcon = generateShareIcon('facebook');
    const TwitterIcon = generateShareIcon('twitter');
    const LinkedinIcon = generateShareIcon('linkedin');
    const GooglePlusIcon = generateShareIcon('google');
    const title = 'LJ Ramos';

    let baseUrl = window.location.origin;
    let detailUrl = window.location.href;
    let newsletterUrl = baseUrl + '/newsletters';
    let shareUrl = detailUrl + '/' + note.id

    return (
      <div>
        <div className="imi note-inside-container">
          <ol className="route-info hidden-xs" itemScope itemType="http://schema.org/BreadcrumbList">
            <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
              <a href={ baseUrl } itemProp="item" itemType="http://schema.org/Thing">
                <span itemProp="name"><small>{t("Informacion_Novedades")}</small></span>
                <meta itemProp="position" content="1" />
              </a>
            </li>
            
            <i className="fa fa-angle-right"></i>
            
            <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
              <a href={ newsletterUrl } itemProp="item" itemType="http://schema.org/Thing">
                <span itemProp="name"><small>{t("Newsletters")}</small></span>
                <meta itemProp="position" content="2" />
              </a>
            </li>
            
            <i className="fa fa-angle-right"></i>
            
            <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
              <a href={ shareUrl } itemProp="item" itemType="http://schema.org/Thing">
                <span itemProp="name"><small>Newsletter {this._renderShortDate(newsletter.date)}</small></span>
                <meta itemProp="position" content="3" />
              </a>
            </li>
          </ol>
          
          <div className="container-fluid">
            <div className="bottom-content visible-xs">
              <div className="left-content">
                <h2>{t("Notas_Relacionadas")}</h2>
                { (related_notes.length > 0) ? (
                  related_notes.map((item, index) =>
                    <Link to={'/note-newsletter/' + item.lug} key={index}>{item.title}</Link>
                  )) : ''
                }

              </div>
              <div className="right-content">
                <p>{t("Compartir")}</p>
                <div className="social-btns">
                  <FacebookShareButton
                    url={shareUrl}
                    title={title}>
                    <FacebookIcon
                      size={30}
                      round={true}
                      iconBgStyle={shareStyle} />
                  </FacebookShareButton>
                  <TwitterShareButton
                    url={shareUrl}
                    title={title}>
                    <TwitterIcon
                      size={30}
                      round={true}
                      iconBgStyle={shareStyle} />
                  </TwitterShareButton>
                  <GooglePlusShareButton
                    url={shareUrl}
                    title={title}>
                    <GooglePlusIcon
                      size={30}
                      round={true}
                      iconBgStyle={shareStyle} />
                  </GooglePlusShareButton>
                  <LinkedinShareButton
                    url={shareUrl}
                    title={title}>
                    <LinkedinIcon
                      size={30}
                      round={true}
                      iconBgStyle={shareStyle} />
                  </LinkedinShareButton>
                </div>
              </div>
            </div>
            <Col md={3} className="col-authors">
              <h4>{t("Autores_informe")}</h4>
              <div className="directors-list">
                { (note.authors) ? (
                  note.authors.map((item, index) =>
                    <div className="director-column" key={index}>
                      <img src={item.image} />
                      <h5>{item.name}</h5>
                      <h6>{item.position}</h6>
                    </div>
                  )) : ''
                }
              </div>
            </Col>
            <Col md={9}>
              <Col md={12} className="col-top-info">
                <Col md={6} className="col-img-detail" style={style}>
                </Col>
                <Col md={6} className="col-note-info">
                  <h2>Newsletter {this._renderShortDate(newsletter.date)}</h2>
                  <h3>{note.title}</h3>
                  <h4>{this._renderDate(note.date)}</h4>
                  <p>{note.bajada}</p>
                  <div className="keywords-list">
                    { (note.keywords) ? (
                      note.keywords.map((item, index) =>
                        <div className="keyword-item" key={index}>
                          <span>{item}</span>
                        </div>
                      )) : ''
                    }
                  </div>
                  <div className="bottom-btns">
                    <a target="_blank" href={newsletter.file}>
                      <Button className="btn-download">
                        <i className="fa fa-download"></i>
                        {t("Descargar_newsletter")}
                      </Button>
                    </a>
                    <div className="link-btn">
                      <Link to="/newsletters">{t("Consultar_otros")}</Link>
                      <i className="fa fa-long-arrow-right"></i>
                    </div>
                  </div>
                </Col>
              </Col>
              <Col md={12} className="content-box">
                <div className="note-content">
                  <p dangerouslySetInnerHTML={this._magic(note.content)} />
                </div>
                <div className="bottom-content hidden-xs">
                  <div className="left-content">
                    <h2>{t("Notas_Relacionadas")}</h2>
                    { (related_notes.length > 0) ? (
                      related_notes.map((item, index) =>
                        <Link to={'/note-newsletter/' + item.slug} key={index}>{item.title}</Link>
                      )) : ''
                    }

                  </div>
                  <div className="right-content">
                    <p>{t("Compartir")}</p>
										<div className="social-btns">
                    <FacebookShareButton
                      url={shareUrl}
                      title={title}>
                      <FacebookIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </FacebookShareButton>
                    <TwitterShareButton
                      url={shareUrl}
                      title={title}>
                      <TwitterIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </TwitterShareButton>
                    <GooglePlusShareButton
                      url={shareUrl}
                      title={title}>
                      <GooglePlusIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </GooglePlusShareButton>
                    <LinkedinShareButton
                      url={shareUrl}
                      title={title}>
                      <LinkedinIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </LinkedinShareButton>
										</div>
                  </div>
                </div>
              </Col>
            </Col>
          </div>
        </div>
        <div className="form-newsletter-container">
          <Newsletter />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Newsletter/Detail/index.js